// Wallpaper of the /pro desktop. It's the same picture as the laptop screen
// in the home scene (/jungle/screen.jpg), which is what makes the dive from
// the scene into the desktop read as one continuous shot.
export const DESKTOP_WALLPAPER = '/background1.webp';
export const SCENE_SCREEN_IMAGE = '/jungle/screen.jpg';
